import { Avatar, TeamDot } from "@/components/Avatar";

export const PlayerChip = ({ p, onClick, selected, testid, right }) => (
  <button type="button" onClick={onClick} data-testid={testid} disabled={!onClick}
    className={`w-full flex items-center gap-3 rounded-2xl border px-3 py-2.5 text-left transition-colors ${selected ? "bg-cyan-50 border-cyan-400" : "bg-white border-slate-200"} ${onClick ? "active:scale-[0.98]" : ""}`}>
    <Avatar user={p} className="w-10 h-10 text-xs" />
    <div className="flex-1 min-w-0">
      <p className="font-semibold text-sm truncate flex items-center gap-1.5">
        {p.short_name}
        {p.is_captain && <span className="text-[9px] font-black bg-amber-400 text-zinc-950 rounded px-1">C</span>}
        {p.is_guest && <span className="text-[9px] font-black bg-orange-100 text-orange-600 rounded px-1">INVITÉ</span>}
      </p>
      <p className="num text-[11px] text-slate-500">{p.primary_position || "—"}{!p.is_guest && p.seniority > 0 ? ` · ${p.seniority} an${p.seniority > 1 ? "s" : ""}` : ""}</p>
    </div>
    <TeamDot team={p.team} />
    {right}
  </button>
);

export const MiniCard = ({ p, onClick, selected, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`flex flex-col items-center gap-1 rounded-2xl border p-2 transition-all active:scale-95 ${selected ? "bg-cyan-400 border-cyan-300 text-zinc-950 scale-[1.03] shadow-lg shadow-cyan-500/30" : "bg-white border-slate-200"}`}>
    <Avatar user={p} className="w-12 h-12 text-sm" ring={selected ? "border-2 border-white" : "border-2 border-white shadow-sm"} />
    <span className="text-xs font-bold truncate max-w-full">{p.short_name}</span>
    <span className={`num text-[10px] font-bold ${selected ? "text-zinc-800" : "text-cyan-600"}`}>{p.primary_position}{p.is_guest ? " · invité" : ""}</span>
  </button>
);
